import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/auth/Login'
import RootView from '@/views/layout/RootView'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'v-list__tile--active',
  scrollBehavior: function(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/password-reset',
      name: 'passwordResetRequest',
      component: () => import('./views/auth/PasswordResetRequest.vue')
    },
    {
      path: '/password-reset/:token',
      name: 'passwordReset',
      component: () => import('./views/auth/PasswordReset.vue')
    },
    {
      path: '/',
      component: RootView,
      children: [
        {
          path: 'pregled',
          name: 'pregled' ,
          component: () => import('./views/Dashboard.vue'),
          alias: '',
          meta: { requiresAuth: true}
        },
        {
          path: 'seznam-uporabnikov',
          name: 'users-list',
          component: () => import('./views/UsersList.vue'),
          meta: { requiresAuth: true}
        },
        {
          path: 'dodaj-uporabnika',
          name: 'add-user',
          component: () => import('@/views/AddUser.vue'),
          meta: { requiresAuth: true}
        },
        {
          path: 'seznam-uporabnikov/:id',
          name: 'edit-user',
          component: () => import('@/views/EditUser.vue'),
          meta: { requiresAuth: true}
        },
        {
          path: 'test',
          name: 'test',
          component:() => import('@/views/Test.vue')
        }
      ]
    },
    /* ERRORS */
    {
      path: '*',
      name: '404',
      component: () => import('@/views/pages/NotFound.vue')
    },
    {
      path: '403',
      name: '403',
      component: () => import('@/views/pages/Deny.vue')
    },
    {
      path: '500',
      name: '500',
      component: () => import('@/views/pages/Error.vue')
    }

  ]
})
